import UAParser from 'ua-parser-js';

import {
  DEVICE_TYPE,
  MAC_OS_NAME,
  IOS_OS_NAME,
  LINUX_OS_NAME,
  ANDROID_OS_NAME,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_IOS,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_PO,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_ANDROID,
  POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_MAC,
  DOC_FORMAT_CONFIG_PREDEFINED,
  DOC_FORMAT_CONFIG_VALUES,
  LANGUAGE,
  DOCUMENT_TYPE,
  QS_CONSTANT,
  USE_REACT_ROUTER,
  PRODUCT_TYPE_WHEN_ROUTING,
  STARTMODE_WHEN_ROUTING,
  PRODUCT_TYPE,
  URLS,
  DIALOG_TYPE
} from '../define/global';
import { NAVERWORKS_DRIVE_TYPE } from '../define/naverworksDefine';

import { getQSObject, getValueOfQSObject } from './qsUtils';
import { HwpTemplate } from '../define/templateFileData/hwp';
import { SheetTemplate } from '../define/templateFileData/sheet';
import { SlideTemplate } from '../define/templateFileData/slide';
import { WordTemplate } from '../define/templateFileData/word';
import formatImgHwp from '../img/ico_file_32_hwp.png';
import formatImgHwp2x from '../img/ico_file_32_hwp@2x.png';
import formatImgSheet from '../img/ico_file_32_sheet.png';
import formatImgSheet2x from '../img/ico_file_32_sheet@2x.png';
import formatImgSlide from '../img/ico_file_32_slide.png';
import formatImgSlide2x from '../img/ico_file_32_slide@2x.png';
import formatImgWord from '../img/ico_file_32_word.png';
import formatImgWord2x from '../img/ico_file_32_word@2x.png';
import formatImgMobileHwp from '../img/title_mobile_file_hwp.png';
import formatImgMobileHwp2x from '../img/title_mobile_file_hwp@2x.png';
import formatImgMobileSheet from '../img/title_mobile_file_sheet.png';
import formatImgMobileSheet2x from '../img/title_mobile_file_sheet@2x.png';
import formatImgMobileSlide from '../img/title_mobile_file_slide.png';
import formatImgMobileSlide2x from '../img/title_mobile_file_slide@2x.png';
import formatImgMobileWord from '../img/title_mobile_file_word.png';
import formatImgMobileWord2x from '../img/title_mobile_file_word@2x.png';
import formatIconHwp from '../img/title_file_hwp.png';
import formatIconHwp2x from '../img/title_file_hwp@2x.png';
import formatIconSheet from '../img/title_file_sheet.png';
import formatIconSheet2x from '../img/title_file_sheet@2x.png';
import formatIconSlide from '../img/title_file_slide.png';
import formatIconSlide2x from '../img/title_file_slide@2x.png';
import formatIconWord from '../img/title_file_word.png';
import formatIconWord2x from '../img/title_file_word@2x.png';
import { sendMoveHomeGAData } from './gaUtil';
import { useAppDataSliceSelector } from '../store/modules/appData';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../context/indexedDBContext';
import { useDispatch } from 'react-redux';
import { usePOWebofficeSDKState } from '../context/poWebOfficeSDKContext';
import { showAppInstall } from '../store/modules/popup';
import { setFileName } from '../store/modules/docInfo';
import { useTranslation } from 'react-i18next';
import { useGenConfirmPromise } from '../components/confirm/Confirm';
import { openDialog } from '../store/modules/dialog';
import { selectCurrentProductFromPath } from './productSelector';
import { setNaverWorksFileInfo } from '../store/modules/naverWorksData';
import { ACTIVELINK_TYPE } from '../define/activeLinkDefine';

export const getPOClientDownloadURL = ({ appData, lang }) => {
  let downloadURL = POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_PO;
  switch (appData.clientOS) {
    case MAC_OS_NAME:
      downloadURL = POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_MAC;
      break;
    case IOS_OS_NAME:
      downloadURL = POLARIS_OFFICE_CLIENT_DOWNLOAD_IOS;
      break;
    case ANDROID_OS_NAME:
      downloadURL = POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_ANDROID;
      break;
    case LINUX_OS_NAME:
      if (appData.deviceType === DEVICE_TYPE.MOBILE || appData.deviceType === DEVICE_TYPE.TABLET)
        downloadURL = POLARIS_OFFICE_CLIENT_DOWNLOAD_URL_ANDROID;
      break;
    default:
      break;
  }
  return downloadURL;
};

export const movePOClientDownloadURL = ({ appData, lang }) => {
  const downloadURL = getPOClientDownloadURL({ appData, lang });
  window.open(downloadURL, '_blank', 'noopener,noreferrer');
};

export const isDevicePC = (deviceType) => deviceType === DEVICE_TYPE.PC;

export const isDevMode = () => process.env.NODE_ENV === 'development';
export const isProductionMode = () => process.env.NODE_ENV === 'production';

export const isSupportDocFormat = (ext) =>
  DOC_FORMAT_CONFIG_VALUES.extList.includes(ext.toLowerCase());

export const useCheckWrongSupportDocFormat = () => {
  const getHomeURLWithProductType = useGetHomeURLWithProductType();
  return (ext) => {
    for (const key in DOC_FORMAT_CONFIG_PREDEFINED) {
      if (DOC_FORMAT_CONFIG_PREDEFINED[key].extList.includes(ext.toLowerCase())) {
        return {
          correctFormat: DOC_FORMAT_CONFIG_PREDEFINED[key].sdk.documnetType,
          correctUrl: getHomeURLWithProductType(
            DOC_FORMAT_CONFIG_PREDEFINED[key].sdk.documnetType,
            STARTMODE_WHEN_ROUTING.OPEN_MOST_RECENT_DOC
          )
        };
      }
    }
    return null;
  };
};

export const isSupportOfflineMode = () => process.env.REACT_APP_SUPPORT_OFFLINE_MODE === 'true';

export class StopWatch {
  startTime;
  start() {
    this.startTime = new Date();
  }

  getElapsedTime() {
    return new Date() - this.startTime;
  }
}

const convWhaleToStandAloneInUseRouter = (type) => {
  if (type === QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_WHALE_SPACE)
    return QS_CONSTANT.PRODUCT_TYPE.VALUES.STANDALONE;

  return type;
};

export const getProductTypeFromQSObject = () => {
  const query = getQSObject();
  const productType = USE_REACT_ROUTER
    ? selectCurrentProductFromPath(location.pathname)
    : convWhaleToStandAloneInUseRouter(getValueOfQSObject(query, QS_CONSTANT.PRODUCT_TYPE.KEY));

  return productType;
};

export const parseInfoFromUA = () => {
  const parser = new UAParser();

  //const isApple = navigator.vendor && navigator.vendor.indexOf('Apple') > -1;
  const isApple = /MacIntel|iPad|iPhone|iPod/i.test(navigator.platform);
  let deviceType = parser.getDevice().type;
  let isPCView = isDevicePC(deviceType);
  let clientOS = isApple ? (isPCView ? MAC_OS_NAME : IOS_OS_NAME) : parser.getOS().name;

  //Exception Haldling: From IPAD OS 13 or higher, IPAD OS is changed to MAC OS
  //Except WhaleSpace
  const isWhaleSpace =
    getProductTypeFromQSObject() === QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_WHALE_SPACE;
  if (!isWhaleSpace && clientOS === MAC_OS_NAME) {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (isIOS) {
      clientOS = IOS_OS_NAME;
      deviceType = DEVICE_TYPE.MOBILE;
      isPCView = false;
    }
  }

  //Mac & Ipad(Up to 13 Version) : Safari, Ipad & IOS : Mobile Safari
  const isUnsupportDownload =
    clientOS === IOS_OS_NAME && /Safari/i.test(parser.getBrowser().name) === false;

  return { deviceType, isPCView, clientOS, isUnsupportDownload };
};

export const getLanguage = (i18nLang) => {
  const lang = i18nLang.split('-')[0].toLowerCase();
  switch (lang) {
    case 'ko':
      return LANGUAGE.KO;
    case 'ja':
      return LANGUAGE.JA;
    case 'es':
      return LANGUAGE.ES;
    default:
      return LANGUAGE.EN;
  }
};

export const getTemplates = (documnetType) => {
  switch (documnetType) {
    case DOCUMENT_TYPE.HWP:
      return HwpTemplate;
    case DOCUMENT_TYPE.SHEET:
      return SheetTemplate;
    case DOCUMENT_TYPE.SLIDE:
      return SlideTemplate;
    case DOCUMENT_TYPE.WORD:
      return WordTemplate;
    default:
      return;
  }
};

export const getFormatImg = (documnetType) => {
  switch (documnetType) {
    case DOCUMENT_TYPE.HWP:
      return {
        formatImg: formatImgHwp,
        formatImg2x: formatImgHwp2x,
        formatImgMobile: formatImgMobileHwp,
        formatImgMobileSlide2x: formatImgMobileHwp2x,
        formatIcon: formatIconHwp,
        formatIcon2x: formatIconHwp2x
      };
    case DOCUMENT_TYPE.SHEET:
      return {
        formatImg: formatImgSheet,
        formatImg2x: formatImgSheet2x,
        formatImgMobile: formatImgMobileSheet,
        formatImgMobileSlide2x: formatImgMobileSheet2x,
        formatIcon: formatIconSheet,
        formatIcon2x: formatIconSheet2x
      };
    case DOCUMENT_TYPE.SLIDE:
      return {
        formatImg: formatImgSlide,
        formatImg2x: formatImgSlide2x,
        formatImgMobile: formatImgMobileSlide,
        formatImgMobileSlide2x: formatImgMobileSlide2x,
        formatIcon: formatIconSlide,
        formatIcon2x: formatIconSlide2x
      };
    case DOCUMENT_TYPE.WORD:
      return {
        formatImg: formatImgWord,
        formatImg2x: formatImgWord2x,
        formatImgMobile: formatImgMobileWord,
        formatImgMobileSlide2x: formatImgMobileWord2x,
        formatIcon: formatIconWord,
        formatIcon2x: formatIconWord2x
      };
    default:
      return;
  }
};

export const genEmbedCode = (src) => {
  return `<iframe width="1024px" height="1000px" src="${src}" title="PO HWP" style="border:none"></iframe>`;
};

export const getUrlProductTypeQuery = () => {
  const query = getQSObject();
  const parsingRes = getValueOfQSObject(query, QS_CONSTANT.PRODUCT_TYPE.KEY);
  const productType = query[QS_CONSTANT.PRODUCT_TYPE.KEY]
    ? `${QS_CONSTANT.PRODUCT_TYPE.KEY}=${parsingRes}`
    : null;
  return productType;
};

export const useGetHomeURLWithProductType = () => {
  const appData = useAppDataSliceSelector();
  return (type, startMode = STARTMODE_WHEN_ROUTING.OPEN_DOCUMENT_OPENABLE_DIALOG) => {
    const hostsplited = window.location.hostname.split('.');
    const protocol = window.location.protocol;
    const port = window.location.port !== '' ? `:${window.location.port}` : '';

    if (USE_REACT_ROUTER === true) {
      const productType =
        appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE
          ? PRODUCT_TYPE_WHEN_ROUTING.WHALE_SPACE
          : PRODUCT_TYPE_WHEN_ROUTING.DEV;

      const parameter = appData.extensionConnectMode === true ? '?extConMode=true' : '';

      let url = '';
      if (isDevMode()) {
        url = `${protocol}//vf-edu.polarisoffice.com${port}/${productType}/${type.toLowerCase()}`;
      } else {
        switch (hostsplited[0]) {
          case 'vf-edu':
            url = `${URLS.EDITOR._EDU_DEV}${productType}/${type.toLowerCase()}`;
            break;
          case 'edu':
            url = `${URLS.EDITOR.EDU}${productType}/${type.toLowerCase()}`;
            break;
          default:
            break;
        }
      }
      return `${url}/${startMode}/${parameter}`;
    } else {
      if (hostsplited.length === 3) {
        if (isDevMode()) {
          switch (type.toLowerCase()) {
            case DOCUMENT_TYPE.HWP:
              return `${protocol}//vf-webeditor.polarisoffice.com${port}`;
            case DOCUMENT_TYPE.SHEET:
              return `${protocol}//vf-websheet.polarisoffice.com${port}`;
            case DOCUMENT_TYPE.SLIDE:
              return `${protocol}//vf-webslide.polarisoffice.com${port}`;
            case DOCUMENT_TYPE.WORD:
              return `${protocol}//vf-webword.polarisoffice.com${port}`;
            default:
              break;
          }
        } else {
          switch (hostsplited[0]) {
            case 'vf-webeditor':
            case 'vf-websheet':
            case 'vf-webslide':
            case 'vf-webword':
              return DOC_FORMAT_CONFIG_PREDEFINED[type.toUpperCase()].url._dev;
            case 'hwp':
            case 'sheet':
            case 'slide':
            case 'word':
              return DOC_FORMAT_CONFIG_PREDEFINED[type.toUpperCase()].url.base;
            default:
              break;
          }
        }
      }
    }
    return '';
  };
};

export const useLinkEditorUrl = () => {
  const getHomeUrl = useGetHomeURLWithProductType();

  return (type, dialogType) => {
    sendMoveHomeGAData(type, dialogType);
    window.open(getHomeUrl(type.toUpperCase()), '_blank', 'noopener,noreferrer');
  };
};

export const useOpenNewTabWithQueryinSameDomain = () => {
  const appData = useAppDataSliceSelector();
  const getHomeURLWithProductType = useGetHomeURLWithProductType();
  return USE_REACT_ROUTER
    ? (startMode) => {
        const getStartMode = () => {
          switch (startMode) {
            case QS_CONSTANT.START_MODE.VALUES.NEW_DOC: {
              return STARTMODE_WHEN_ROUTING.NEW_DOC;
            }
            case QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC: {
              return STARTMODE_WHEN_ROUTING.OPEN_MOST_RECENT_DOC;
            }
            case QS_CONSTANT.START_MODE.VALUES.SHARE_VIEW: {
              return STARTMODE_WHEN_ROUTING.SHARE_VIEW;
            }
            case QS_CONSTANT.START_MODE.VALUES.OPEN_DOCUMENT_OPENABLE_DIALOG: {
              return STARTMODE_WHEN_ROUTING.OPEN_DOCUMENT_OPENABLE_DIALOG;
            }
          }
        };

        const target = getHomeURLWithProductType(
          DOC_FORMAT_CONFIG_VALUES.sdk.documnetType,
          getStartMode()
        );
        window.open(target, '_blank', 'noopener,noreferrer');
      }
    : (startMode) => {
        const productTypeQuery = getUrlProductTypeQuery();
        const url = productTypeQuery
          ? `/?${productTypeQuery}&${QS_CONSTANT.START_MODE.KEY}=${startMode}`
          : `/?${QS_CONSTANT.START_MODE.KEY}=${startMode}`;

        window.open(url, '_blank', 'noopener,noreferrer');
      };
};

export const useOpenCurrentTab = () => {
  const dispatch = useDispatch();
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const appDataSlice = useAppDataSliceSelector();
  const isPCView = isDevicePC(appDataSlice.deviceType);
  const poSDKContextState = usePOWebofficeSDKState();
  const poSDKReady = poSDKContextState.poInstance !== null;
  return (file, callback, isNaverWorksFile = false, naverWorksFileInfo = null) => {
    if (poSDKReady) {
      const targetFile = file;
      const fileName = targetFile.name;

      const docinfo = {
        name: fileName,
        blob: targetFile
      };

      const stopWatch = new StopWatch();
      stopWatch.start();
      poSDKContextState.poInstance.handle.openDocument(docinfo).then(() => {
        saveFile({
          state: indexedDBState,
          dispatch: indexedDBDispatch,
          file: targetFile,
          isNaverWorksFile,
          naverWorksFileInfo
        });
        dispatch(setFileName(fileName));
        if (isNaverWorksFile && naverWorksFileInfo) {
          dispatch(setNaverWorksFileInfo(naverWorksFileInfo));
        }

        if (!isPCView && appDataSlice.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE) {
          dispatch(showAppInstall());
        }

        if (callback) callback(stopWatch.getElapsedTime(), docinfo.blob);
      });
    }
  };
};

export const blobToBase64 = function (blob, callback) {
  const reader = new FileReader();

  return new Promise((resove, reject) => {
    reader.onload = function () {
      const dataUrl = reader.result;
      //const base64 = dataUrl.split(',')[1];
      resove(dataUrl);
    };
    reader.readAsDataURL(blob);
  });
};

export const useArrangeButtonOrder = () => {
  const { i18n } = useTranslation();
  const appData = useAppDataSliceSelector();
  const lang = getLanguage(i18n.language);
  return (array) => {
    if (appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE) {
      const wordIndex = array.findIndex((element) => element.type === DOCUMENT_TYPE.WORD);
      const hwpIndex = array.findIndex((element) => element.type === DOCUMENT_TYPE.HWP);

      if (wordIndex > -1 && hwpIndex > -1) {
        if (
          (lang === LANGUAGE.KO && hwpIndex > wordIndex) ||
          (lang !== LANGUAGE.KO && hwpIndex < wordIndex)
        ) {
          const temp = array[wordIndex];
          array[wordIndex] = array[hwpIndex];
          array[hwpIndex] = temp;
        }
      }
    }
    return array;
  };
};

export const useUploadItt = () => {
  const confirmPromise = useGenConfirmPromise();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return async () => {
    const confirm = await confirmPromise({ message: t('Header.ConfirmUpload') });
    if (confirm) {
      dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_UPLOAD_ITT }));
    }
  };
};

export const checkSupportNaverWorksDriveType = (driveType) =>
  Object.values(NAVERWORKS_DRIVE_TYPE).includes(driveType);

export const getActiveLinkType = (whitelist, url) => {
  try {
    const activeLinkDomain = whitelist;
    const urlObj = new URL(url);
    const check = `${urlObj.host.replace('www.', '')}${urlObj.pathname}`;
    const index = activeLinkDomain.findIndex((domain) => check.startsWith(domain));
    if (index < 0) {
      return ACTIVELINK_TYPE.NONE;
    } else {
      const found = activeLinkDomain[index];
      if (found.startsWith('vf-pwc.polarisoffice.com') || found.startsWith('polariscanvas.io')) {
        return ACTIVELINK_TYPE.CANVAS;
      }
      return ACTIVELINK_TYPE.ACTIVELINK;
    }
  } catch (err) {
    return ACTIVELINK_TYPE.NONE;
  }
};
